(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cart-section]').forEach((section) => {
    const form = section.querySelector('#cart-form');
    if (!form) return;

    const applyDiscount = (code) => {
      const trimmed = (code || '').trim();
      if (!trimmed) return;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = `${root}discount/${encodeURIComponent(trimmed)}?redirect=${encodeURIComponent('/cart')}`;
    };

    const discountStatus = section.querySelector('[data-discount-status]');
    const appliedDiscountCodes = () =>
      Array.from(section.querySelectorAll('[data-discount-remove]'))
        .map((button) => button.dataset.discountCode)
        .filter(Boolean);

    const updateDiscountCodes = async (codes) => {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ discount: codes.join(',') }),
      });

      if (!response.ok) throw new Error('Discount update failed');
      return response.json();
    };

    section.querySelectorAll('[data-qty]').forEach((qty) => {
      const input = qty.querySelector('[data-qty-input]');
      qty.querySelectorAll('[data-qty-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const delta = Number(button.dataset.qtyChange);
          const next = Math.max(0, Number(input.value || 0) + delta);
          input.value = String(next);
          form.submit();
        });
      });
      input.addEventListener('change', () => form.submit());
    });

    const discountInput = section.querySelector('[data-discount-input]');
    const discountApply = section.querySelector('[data-discount-apply]');
    if (discountApply && discountInput) {
      discountApply.addEventListener('click', () => applyDiscount(discountInput.value));
      discountInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyDiscount(discountInput.value);
        }
      });
    }

    section.querySelectorAll('[data-deal-code]').forEach((button) => {
      button.addEventListener('click', () => {
        const code = button.dataset.dealCode;
        if (discountInput) discountInput.value = code;
        applyDiscount(code);
      });
    });

    section.querySelectorAll('[data-discount-remove]').forEach((button) => {
      button.addEventListener('click', async () => {
        const codeToRemove = button.dataset.discountCode;
        const remainingCodes = appliedDiscountCodes().filter((code) => code !== codeToRemove);
        if (discountStatus) discountStatus.textContent = '';
        button.disabled = true;

        try {
          await updateDiscountCodes(remainingCodes);
          window.location.reload();
        } catch (error) {
          button.disabled = false;
          if (discountStatus) discountStatus.textContent = discountStatus.dataset.errorMessage;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterDrawer = document.querySelector('[data-filter-drawer]');

  if (filterToggle && filterDrawer) {
    const closeFilter = () => {
      filterDrawer.classList.remove('is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      filterToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('filter-drawer-open');
    };

    filterToggle.addEventListener('click', () => {
      const isOpen = filterDrawer.classList.toggle('is-open');
      filterDrawer.setAttribute('aria-hidden', String(!isOpen));
      filterToggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('filter-drawer-open', isOpen);
    });

    for (const button of filterDrawer.querySelectorAll('[data-filter-close]')) {
      button.addEventListener('click', closeFilter);
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && filterDrawer.classList.contains('is-open')) closeFilter();
    });
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.main-collection__sort select');
    if (select) select.form.submit();
  });

  for (const form of document.querySelectorAll('.main-collection__price-form')) {
    const minimum = form.querySelector('[data-price-min]');
    const maximum = form.querySelector('[data-price-max]');
    const minimumOutput = form.querySelector('[data-price-min-output]');
    const maximumOutput = form.querySelector('[data-price-max-output]');
    const formatPrice = (value) =>
      new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: form.dataset.currency,
        maximumFractionDigits: 0,
      }).format(value);

    const updatePriceRange = (changedInput) => {
      if (Number(minimum.value) > Number(maximum.value)) {
        if (changedInput === minimum) {
          minimum.value = maximum.value;
        } else {
          maximum.value = minimum.value;
        }
      }

      minimumOutput.textContent = formatPrice(Number(minimum.value));
      maximumOutput.textContent = formatPrice(Number(maximum.value));
    };

    minimum.addEventListener('input', () => updatePriceRange(minimum));
    maximum.addEventListener('input', () => updatePriceRange(maximum));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const centerHomeCollection = (scope = document) => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      for (const grid of scope.querySelectorAll('.collections-grid--home .collections-grid__grid')) {
        if (grid.dataset.mobilePositioned === 'true') continue;

        const firstCollectionCard = grid.querySelector('.collections-grid__tile:not(.collections-grid__view-all)');
        if (!firstCollectionCard) continue;

        grid.dataset.mobilePositioned = 'true';
        requestAnimationFrame(() => {
          grid.scrollLeft = firstCollectionCard.offsetLeft - (grid.clientWidth - firstCollectionCard.offsetWidth) / 2;
        });
      }
    };

    centerHomeCollection();
    document.addEventListener('shopify:section:load', (event) => centerHomeCollection(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    for (const accordion of document.querySelectorAll('[data-faq-page-accordion]')) {
      const items = accordion.querySelectorAll('.faq-page__item');

      for (const item of items) {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          for (const otherItem of items) {
            if (otherItem !== item) otherItem.open = false;
          }
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-faq-accordion]').forEach((faq) => {
      const items = faq.querySelectorAll('.faq__item');

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          items.forEach((other) => {
            if (other !== item) {
              other.open = false;
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const menu = document.querySelector('[data-footer-menu]');
    const groups = menu ? [...menu.querySelectorAll('[data-footer-group]')] : [];
    if (!menu || groups.length === 0) return;

    let closeTimer;

    const closeGroups = (exceptGroup) => {
      for (const group of groups) {
        if (group === exceptGroup) continue;
        group.classList.remove('is-open');
        group.querySelector('[data-footer-trigger]')?.setAttribute('aria-expanded', 'false');
      }
    };

    const openGroup = (group) => {
      window.clearTimeout(closeTimer);
      closeGroups(group);
      group.classList.add('is-open');
      group.querySelector('[data-footer-trigger]')?.setAttribute('aria-expanded', 'true');
    };

    const closeGroup = (group) => {
      closeTimer = setTimeout(() => {
        group.classList.remove('is-open');
        group.querySelector('[data-footer-trigger]')?.setAttribute('aria-expanded', 'false');
      }, 120);
    };

    for (const group of groups) {
      const trigger = group.querySelector('[data-footer-trigger]');
      if (!trigger) continue;

      group.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch') openGroup(group);
      });
      group.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'touch') closeGroup(group);
      });
      group.addEventListener('focusin', (event) => {
        if (event.target.matches(':focus-visible')) openGroup(group);
      });
      group.addEventListener('focusout', (event) => {
        if (!group.contains(event.relatedTarget)) closeGroup(group);
      });

      trigger.addEventListener('click', () => {
        const willOpen = !group.classList.contains('is-open');
        closeGroups();
        if (willOpen) openGroup(group);
      });
    }

    document.addEventListener('click', (event) => {
      if (!menu.contains(event.target)) closeGroups();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const sectionRoot = header.closest('.shopify-section');
    if (!sectionRoot) return;

    const transparentHeader = header.classList.contains('site-header--transparent') ? header : null;
    const toggleButtons = Array.from(sectionRoot.querySelectorAll('[data-header-toggle]'));
    const modals = Array.from(sectionRoot.querySelectorAll('[data-header-modal]'));
    const searchForms = Array.from(sectionRoot.querySelectorAll('.site-header__search-bar'));
    const searchPanel = sectionRoot.querySelector('[data-header-modal="search"]');
    const searchInput = sectionRoot.querySelector('[data-header-search-input]');
    const searchClose = sectionRoot.querySelector('[data-header-search-close]');
    const predictiveSearch = sectionRoot.querySelector('[data-predictive-search]');
    const predictiveResults = sectionRoot.querySelector('[data-predictive-results]');
    const predictiveLoading = sectionRoot.querySelector('[data-predictive-loading]');
    const menuGroups = Array.from(sectionRoot.querySelectorAll('[data-header-menu-group]'));
    const predictiveCache = new Map();
    let menuCloseTimer;
    let predictiveTimer;
    let predictiveController;

    const hidePredictiveSearch = () => {
      window.clearTimeout(predictiveTimer);
      predictiveController?.abort();
      predictiveController = null;
      if (predictiveSearch) predictiveSearch.hidden = true;
      if (predictiveLoading) predictiveLoading.hidden = true;
      if (predictiveResults) predictiveResults.innerHTML = '';
      if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
      searchPanel?.classList.remove('site-header__search-panel--results');
    };

    const showPredictiveMarkup = (markup) => {
      if (!predictiveSearch || !predictiveResults || !searchInput) return;
      predictiveLoading.hidden = true;
      predictiveResults.innerHTML = markup;
      predictiveSearch.hidden = false;
      searchInput.setAttribute('aria-expanded', 'true');
      searchPanel?.classList.add('site-header__search-panel--results');
    };

    const getShopifySearchQuery = (query) => {
      const trimmedQuery = query.trim();
      const audienceTagQueries = new Map([
        ['woman', 'tag:women'],
        ['women', 'tag:women'],
        ["women's", 'tag:women'],
        ['womens', 'tag:women'],
        ['female', 'tag:women'],
        ['man', 'tag:men'],
        ['men', 'tag:men'],
        ["men's", 'tag:men'],
        ['mens', 'tag:men'],
        ['male', 'tag:men']
      ]);

      return trimmedQuery
        .split(/\s+/)
        .map((term) => audienceTagQueries.get(term.toLocaleLowerCase()) || term)
        .join(' ');
    };

    const getPredictiveSearch = async (query) => {
      if (!predictiveSearch || !predictiveResults || !searchInput) return;

      const cacheKey = query.toLocaleLowerCase();
      if (predictiveCache.has(cacheKey)) {
        showPredictiveMarkup(predictiveCache.get(cacheKey));
        return;
      }

      predictiveController?.abort();
      predictiveController = new AbortController();
      predictiveSearch.hidden = false;
      predictiveLoading.hidden = false;
      predictiveResults.innerHTML = '';
      searchInput.setAttribute('aria-expanded', 'true');
      searchPanel?.classList.add('site-header__search-panel--results');

      const url = new URL(predictiveSearch.dataset.predictiveSearchUrl, window.location.origin);
      url.searchParams.set('q', getShopifySearchQuery(query));
      url.searchParams.set('section_id', predictiveSearch.dataset.predictiveSectionId);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '5');
      url.searchParams.set('resources[options][unavailable_products]', 'last');

      try {
        const response = await fetch(url, {
          signal: predictiveController.signal,
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Predictive search request failed');

        const responseText = await response.text();
        const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
        const content = responseDocument.querySelector('[data-predictive-search-content]');
        if (!content) throw new Error('Predictive search content missing');

        const currentQuery = searchInput.value.trim();
        if (currentQuery.toLocaleLowerCase() !== cacheKey) return;

        predictiveCache.set(cacheKey, content.innerHTML);
        showPredictiveMarkup(content.innerHTML);
      } catch (error) {
        if (error.name !== 'AbortError') hidePredictiveSearch();
      }
    };

    const queuePredictiveSearch = () => {
      if (!searchInput) return;
      const query = searchInput.value.trim();
      window.clearTimeout(predictiveTimer);

      if (query.length < 2) {
        hidePredictiveSearch();
        return;
      }

      predictiveTimer = window.setTimeout(() => getPredictiveSearch(query), 280);
    };

    const closeMenuGroups = (exceptGroup) => {
      for (const group of menuGroups) {
        if (group === exceptGroup) continue;
        group.classList.remove('is-open');
        group.querySelector('[data-header-menu-trigger]')?.setAttribute('aria-expanded', 'false');
      }
    };

    const openMenuGroup = (group) => {
      window.clearTimeout(menuCloseTimer);
      closeMenuGroups(group);
      group.classList.add('is-open');
      group.querySelector('[data-header-menu-trigger]')?.setAttribute('aria-expanded', 'true');
    };

    const closeMenuGroup = (group) => {
      menuCloseTimer = window.setTimeout(() => {
        group.classList.remove('is-open');
        group.querySelector('[data-header-menu-trigger]')?.setAttribute('aria-expanded', 'false');
      }, 120);
    };

    const setToggleLabel = (button, label) => {
      if (!button) return;

      const labelTarget = button.querySelector('[data-header-toggle-label]') || button;
      if (labelTarget.textContent.trim() === label) return;

      button.style.opacity = '0';
      window.setTimeout(() => {
        labelTarget.textContent = label;
        button.style.opacity = '1';
      }, 140);
    };

    const closeModals = () => {
      closeMenuGroups();
      hidePredictiveSearch();

      modals.forEach((modal) => {
        modal.classList.remove('site-header__overlay--open');
        modal.setAttribute('aria-hidden', 'true');
      });

      toggleButtons.forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
        setToggleLabel(button, button.dataset.labelOpen);
      });

      header.classList.remove('site-header--modal-open');
      document.body.classList.remove('site-header-modal-open');
    };

    const openModal = (name) => {
      const activeModal = modals.find((modal) => modal.dataset.headerModal === name);
      const activeButton = toggleButtons.find((button) => button.dataset.headerToggle === name);

      if (!activeModal || !activeButton) return;

      const isOpen = activeModal.classList.contains('site-header__overlay--open');
      closeModals();

      if (isOpen) return;

      activeModal.classList.add('site-header__overlay--open');
      activeModal.setAttribute('aria-hidden', 'false');
      activeButton.setAttribute('aria-expanded', 'true');
      setToggleLabel(activeButton, activeButton.dataset.labelClose);

      if (name === 'menu') {
        header.classList.add('site-header--modal-open');
        document.body.classList.add('site-header-modal-open');
      }

      if (name === 'search' && searchInput) {
        window.requestAnimationFrame(() => {
          window.setTimeout(() => {
            searchInput.focus({ preventScroll: true });
            queuePredictiveSearch();
          }, 280);
        });
      }
    };

    toggleButtons.forEach((button) => {
      button.addEventListener('click', () => {
        openModal(button.dataset.headerToggle);
      });
    });

    for (const group of menuGroups) {
      const trigger = group.querySelector('[data-header-menu-trigger]');
      if (!trigger) continue;

      group.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch') openMenuGroup(group);
      });
      group.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'touch') closeMenuGroup(group);
      });
      trigger.addEventListener('click', () => {
        const willOpen = !group.classList.contains('is-open');
        closeMenuGroups();
        if (willOpen) openMenuGroup(group);
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', closeModals);
    }

    modals.forEach((modal) => {
      if (modal.dataset.headerModal === 'menu') {
        modal.addEventListener('click', (event) => {
          if (event.target === modal) closeModals();
        });
      }

      modal.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeModals);
      });
    });

    searchForms.forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const formData = new FormData(form);
        const params = new URLSearchParams(formData);
        const query = params.get('q');
        const action = form.action || '/search';

        if (query === null || query.trim() === '') {
          window.location.href = action;
          return;
        }

        params.set('q', getShopifySearchQuery(query));
        closeModals();
        window.location.href = `${action}?${params.toString()}`;
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', queuePredictiveSearch);
      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' && predictiveSearch && !predictiveSearch.hidden) {
          const firstResult = predictiveSearch.querySelector('.site-header__predictive-link');
          if (firstResult) {
            event.preventDefault();
            firstResult.focus();
          }
          return;
        }

        if (event.key === 'Enter') {
          event.preventDefault();
          if (searchInput.form) searchInput.form.requestSubmit();
        }
      });
    }

    if (predictiveSearch) {
      predictiveSearch.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

        const links = Array.from(predictiveSearch.querySelectorAll('[data-predictive-result-link]'));
        const currentIndex = links.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = (currentIndex + direction + links.length) % links.length;
        links[nextIndex].focus();
      });
    }

    if (transparentHeader) {
      const update = () => {
        transparentHeader.classList.toggle('site-header--scrolled', window.scrollY > 8);
      };
      window.addEventListener('scroll', update, { passive: true });
      update();
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModals();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopViewport = window.matchMedia('(min-width: 750px)');

    const revealSlide = (panel, nextIndex) => {
      if (!panel || panel.dataset.animating === 'true') return;

      const slides = panel.querySelectorAll('[data-slide-index]');
      const current = panel.querySelector('.hero__slide.is-active');
      const next = panel.querySelector(`[data-slide-index="${nextIndex}"]`);
      if (!next || next === current) return;

      panel.dataset.animating = 'true';
      next.classList.add('is-next');

      const complete = () => {
        if (!next.classList.contains('is-next')) return;
        current?.classList.remove('is-active');
        next.classList.remove('is-next', 'is-revealed');
        next.classList.add('is-active');
        panel.dataset.animating = 'false';
      };

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => next.classList.add('is-revealed'));
      });

      next.addEventListener('transitionend', complete, { once: true });
      window.setTimeout(complete, 1200);

      for (const slide of slides) {
        if (slide !== current && slide !== next) slide.classList.remove('is-active', 'is-next', 'is-revealed');
      }
    };

    const initializeShutter = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const leftPanel = root.querySelector('[data-hero-panel="left"]');
      const rightPanel = root.querySelector('[data-hero-panel="right"]');
      const slideCount = leftPanel?.querySelectorAll('[data-slide-index]').length || 0;
      const interval = Number(root.dataset.slideInterval) || 5000;
      if (!leftPanel || !rightPanel || slideCount < 2 || reducedMotion.matches) return;

      let leftIndex = 0;
      let rightIndex = 1;
      let mobileIndex = 0;
      let desktopStep = 0;

      const advance = () => {
        if (desktopViewport.matches) {
          if (desktopStep % 2 === 0) {
            leftIndex = (leftIndex + 2) % slideCount;
            revealSlide(leftPanel, leftIndex);
          } else {
            rightIndex = (rightIndex + 2) % slideCount;
            revealSlide(rightPanel, rightIndex);
          }
          desktopStep += 1;
          return;
        }

        mobileIndex = (mobileIndex + 1) % slideCount;
        revealSlide(leftPanel, mobileIndex);
      };

      let timer = window.setInterval(advance, interval);
      const pause = () => window.clearInterval(timer);
      const resume = () => {
        window.clearInterval(timer);
        timer = window.setInterval(advance, interval);
      };

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          pause();
        } else {
          resume();
        }
      });

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) pause();
      });
    };

    const prepareMarquee = (root) => {
      const track = root?.querySelector('[data-hero-marquee-track]');
      const source = track?.querySelector('[data-hero-marquee-set]');
      if (!track || !source) return;

      track.classList.remove('is-ready');
      for (const clone of track.querySelectorAll('[data-hero-marquee-clone]')) clone.remove();

      const setWidth = source.getBoundingClientRect().width;
      if (!setWidth) return;

      const minWidth = root.getBoundingClientRect().width * 2;
      let totalWidth = setWidth;

      while (totalWidth < minWidth) {
        const clone = source.cloneNode(true);
        clone.removeAttribute('data-hero-marquee-set');
        clone.setAttribute('data-hero-marquee-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        for (const node of clone.querySelectorAll('[data-shopify-editor-block]')) {
          node.removeAttribute('data-shopify-editor-block');
        }
        track.appendChild(clone);
        totalWidth += setWidth;
      }

      if (track.children.length < 2) {
        const clone = source.cloneNode(true);
        clone.removeAttribute('data-hero-marquee-set');
        clone.setAttribute('data-hero-marquee-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      root.style.setProperty('--hero-marquee-shift', `${setWidth}px`);
      if (!reducedMotion.matches) track.classList.add('is-ready');
    };

    const initializeWordmarkScroll = (wordmark) => {
      if (!wordmark || wordmark.dataset.scrollInitialized === 'true') return;

      if (!desktopViewport.matches) {
        wordmark.dataset.scrollInitialized = 'true';
        const hideTimer = window.setTimeout(() => {
          wordmark.hidden = true;
        }, 6000);

        document.addEventListener(
          'shopify:section:unload',
          (event) => {
            if (event.target.contains(wordmark)) window.clearTimeout(hideTimer);
          },
          { once: true }
        );
        return;
      }

      const hero = wordmark.closest('.hero');
      const stage = wordmark.closest('.hero__stage');
      const header = document.querySelector('[data-site-header]');
      const headerLogo = header?.querySelector('[data-home-header-logo]');
      if (!hero || !stage || !header || !headerLogo) return;

      wordmark.dataset.scrollInitialized = 'true';

      let startCenter = 0;
      let startWidth = 0;
      let targetCenter = 0;
      let targetScale = 1;
      let endScroll = 1;
      let frame;

      const update = () => {
        frame = undefined;

        const progress = Math.min(Math.max(window.scrollY / endScroll, 0), 1);
        const scaleProgress = progress * (2 - progress);
        const desiredCenter = startCenter + (targetCenter - startCenter) * progress;
        const naturalCenter = startCenter - window.scrollY;
        const translateY = desiredCenter - naturalCenter;
        const scale = 1 - (1 - targetScale) * scaleProgress;
        const isHeaderWordmarkVisible = progress >= 0.94;
        const isDocked = progress >= 0.985;

        if (reducedMotion.matches) {
          wordmark.style.transform = '';
        } else {
          wordmark.style.transform = `translate3d(0, ${translateY}px, 0) scale(${scale})`;
        }

        wordmark.style.opacity = isDocked ? '0' : '1';
        header.classList.toggle('site-header--wordmark-visible', isHeaderWordmarkVisible);
        header.classList.toggle('site-header--wordmark-traveling', !isDocked);
        header.classList.toggle('site-header--wordmark-docked', isDocked);
      };

      const requestUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      };

      const measure = () => {
        wordmark.style.transform = '';
        wordmark.style.opacity = '1';
        header.classList.remove('site-header--wordmark-visible', 'site-header--wordmark-docked');
        header.classList.add('site-header--wordmark-traveling');

        const wordmarkRect = wordmark.getBoundingClientRect();
        const headerLogoRect = headerLogo.getBoundingClientRect();
        const stageRect = stage.getBoundingClientRect();

        startCenter = wordmarkRect.top + window.scrollY + wordmarkRect.height / 2;
        startWidth = wordmarkRect.width;
        targetCenter = header.getBoundingClientRect().height / 2;
        targetScale = startWidth ? headerLogoRect.width / startWidth : 1;
        endScroll = Math.max(stageRect.top + window.scrollY + stageRect.height - header.offsetHeight, 1);

        update();
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', measure);
      measure();

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (!event.target.contains(wordmark)) return;
          window.removeEventListener('scroll', requestUpdate);
          window.removeEventListener('resize', measure);
          if (frame) window.cancelAnimationFrame(frame);
          header.classList.remove(
            'site-header--wordmark-visible',
            'site-header--wordmark-traveling',
            'site-header--wordmark-docked'
          );
        },
        { once: true }
      );
    };

    const initializeHero = (scope = document) => {
      for (const shutter of scope.querySelectorAll('[data-hero-shutter]')) initializeShutter(shutter);
      for (const marquee of scope.querySelectorAll('[data-hero-marquee]')) prepareMarquee(marquee);
      for (const wordmark of scope.querySelectorAll('[data-hero-wordmark]')) initializeWordmarkScroll(wordmark);
    };

    initializeHero();

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        for (const marquee of document.querySelectorAll('[data-hero-marquee]')) prepareMarquee(marquee);
      }, 150);
    });

    document.addEventListener('shopify:section:load', (event) => initializeHero(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-newsletter-popup]');
    if (!root) return;

    const dialog = root.querySelector('[data-newsletter-dialog]');
    const closeButtons = root.querySelectorAll('[data-newsletter-close]');
    const delay = Number(root.dataset.delay || 3000);
    const isHomepage = root.dataset.homepage === 'true';
    const storageKey = root.dataset.storageKey || 'essencie-newsletter-popup-dismissed';
    const hasSuccess = Boolean(root.querySelector('[data-newsletter-success]'));
    let focusBeforeOpen = null;

    const getFocusable = () =>
      Array.from(
        dialog.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      );

    const openPopup = () => {
      focusBeforeOpen = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('newsletter-popup-open');

      window.requestAnimationFrame(() => {
        root.classList.add('is-open');
        const focusable = getFocusable();
        const email = root.querySelector('.newsletter-popup__email');
        (email || focusable[0] || dialog).focus({ preventScroll: true });
      });
    };

    const closePopup = ({ persist } = { persist: true }) => {
      root.classList.remove('is-open');
      document.body.classList.remove('newsletter-popup-open');

      window.setTimeout(() => {
        root.hidden = true;
        root.setAttribute('aria-hidden', 'true');
        if (focusBeforeOpen && typeof focusBeforeOpen.focus === 'function') {
          focusBeforeOpen.focus({ preventScroll: true });
        }
      }, 400);

      if (persist) {
        try {
          window.sessionStorage.setItem(storageKey, '1');
        } catch (error) {
          // Ignore storage failures (private mode, etc.)
        }
      }
    };

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closePopup());
    });

    document.addEventListener('keydown', (event) => {
      if (root.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getFocusable();
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (hasSuccess) {
      openPopup();
      return;
    }

    if (!isHomepage) return;

    try {
      if (window.sessionStorage.getItem(storageKey) === '1') return;
    } catch (error) {
      // Continue and show popup when storage is unavailable
    }

    window.setTimeout(openPopup, delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  for (const content of document.querySelectorAll('[data-information-content]')) {
    for (const table of content.querySelectorAll('table')) {
      if (table.closest('.information-page__table-figure')) continue;

      // figure > [hint, wrap > table]
      const figure = document.createElement('div');
      figure.className = 'information-page__table-figure';

      const hint = document.createElement('p');
      hint.className = 'information-page__table-hint';
      hint.textContent = content.dataset.tableHint || 'Swipe to see more →';

      const wrapper = document.createElement('div');
      wrapper.className = 'information-page__table-wrap';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', content.dataset.tableLabel);

      table.parentNode.insertBefore(figure, table);
      figure.append(hint, wrapper);
      wrapper.appendChild(table);

      // Only advertise the swipe when the table genuinely overflows, and drop
      // the hint once the reader has worked it out.
      const sync = () => {
        const overflows = wrapper.scrollWidth - wrapper.clientWidth > 4;
        figure.classList.toggle('is-overflowing', overflows);
        if (!overflows) figure.classList.remove('is-scrolled');
      };

      wrapper.addEventListener(
        'scroll',
        () => {
          if (wrapper.scrollLeft > 8) figure.classList.add('is-scrolled');
        },
        { passive: true }
      );

      sync();

      // Keep a reference on the element: an unreferenced ResizeObserver gets
      // garbage collected and silently stops firing.
      if ('ResizeObserver' in window) {
        figure.tableObserver = new ResizeObserver(sync);
        figure.tableObserver.observe(wrapper);
      }
      window.addEventListener('resize', sync, { passive: true });

      // Custom faces load with font-display:swap, and the metric change can
      // push a borderline table into (or out of) overflow.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pdp').forEach((pdp) => {
    const section = pdp.closest('.shopify-section');
    const productJson = section.querySelector('[data-pdp-product]');
    const product = productJson ? JSON.parse(productJson.textContent) : null;

    /* Gallery */
    const info = section.querySelector('.pdp__info');
    const mediaItems = section.querySelectorAll('.pdp__media-item');
    const thumbs = section.querySelectorAll('.pdp__thumb');
    const activateMedia = (index) => {
      mediaItems.forEach((item) => {
        const isActive = item.dataset.index === String(index);
        item.classList.toggle('is-active', isActive);
        item.querySelectorAll('video').forEach((video) => {
          video.muted = true;
          video.loop = true;
          if (isActive) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });
      thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.index === String(index)));
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => activateMedia(thumb.dataset.index)));
    const initialMedia = section.querySelector('.pdp__media-item.is-active');
    if (initialMedia) activateMedia(initialMedia.dataset.index);

    const moveGallery = (direction) => {
      if (!mediaItems.length) return;
      const activeMedia = section.querySelector('.pdp__media-item.is-active');
      const activeIndex = Number(activeMedia?.dataset.index || 0);
      activateMedia((activeIndex + direction + mediaItems.length) % mediaItems.length);
    };
    section.querySelector('[data-gallery-previous]')?.addEventListener('click', () => moveGallery(-1));
    section.querySelector('[data-gallery-next]')?.addEventListener('click', () => moveGallery(1));

    /* ---------- Image zoom lightbox (desktop + mobile) ---------- */
    (() => {
      const media = section.querySelector('.pdp__media');
      const slideEls = Array.from(mediaItems)
        .filter((item) => item.classList.contains('pdp__media-item--image'))
        .map((item) => item.querySelector('.pdp__image'))
        .filter(Boolean);
      if (!media || !slideEls.length) return;

      const slides = slideEls.map((img) => ({
        src: img.dataset.zoomSrc || img.currentSrc || img.src,
        alt: img.alt || '',
      }));
      const total = slides.length;

      const MIN_SCALE = 1;
      const MAX_SCALE = 4;
      let index = 0;
      let scale = 1;
      let tx = 0;
      let ty = 0;
      let lastFocus = null;

      const overlay = document.createElement('div');
      overlay.className = 'pdp-lightbox' + (total < 2 ? ' pdp-lightbox--single' : '');
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Product image viewer');
      overlay.innerHTML =
        '<div class="pdp-lightbox__stage" data-stage>' +
          '<img class="pdp-lightbox__image" data-image alt="" draggable="false">' +
        '</div>' +
        '<button class="pdp-lightbox__control pdp-lightbox__close" type="button" aria-label="Close" data-close>' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<button class="pdp-lightbox__control pdp-lightbox__nav pdp-lightbox__nav--prev" type="button" aria-label="Previous image" data-prev>' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>' +
        '</button>' +
        '<button class="pdp-lightbox__control pdp-lightbox__nav pdp-lightbox__nav--next" type="button" aria-label="Next image" data-next>' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>' +
        '</button>' +
        '<div class="pdp-lightbox__counter"><span data-current>1</span> / <span data-total>' + total + '</span></div>';
      document.body.appendChild(overlay);

      const stage = overlay.querySelector('[data-stage]');
      const imgEl = overlay.querySelector('[data-image]');
      const currentLabel = overlay.querySelector('[data-current]');

      const applyTransform = () => {
        imgEl.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
        stage.classList.toggle('is-zoomed', scale > 1.01);
      };

      const constrain = () => {
        const sRect = stage.getBoundingClientRect();
        const baseW = imgEl.offsetWidth;
        const baseH = imgEl.offsetHeight;
        const maxX = Math.max(0, (baseW * scale - sRect.width) / 2);
        const maxY = Math.max(0, (baseH * scale - sRect.height) / 2);
        tx = Math.min(maxX, Math.max(-maxX, tx));
        ty = Math.min(maxY, Math.max(-maxY, ty));
      };

      const zoomToward = (clientX, clientY, target) => {
        target = Math.min(MAX_SCALE, Math.max(MIN_SCALE, target));
        const prev = scale;
        if (target === prev) return;
        const sRect = stage.getBoundingClientRect();
        const px = clientX - (sRect.left + sRect.width / 2);
        const py = clientY - (sRect.top + sRect.height / 2);
        const k = target / prev;
        scale = target;
        tx = tx * k + px * (1 - k);
        ty = ty * k + py * (1 - k);
        if (scale <= 1.01) {
          scale = 1;
          tx = 0;
          ty = 0;
        }
        constrain();
        applyTransform();
      };

      const resetZoom = () => {
        scale = 1;
        tx = 0;
        ty = 0;
        imgEl.style.transform = '';
        stage.classList.remove('is-zoomed', 'is-panning');
      };

      const show = (i) => {
        index = (i + total) % total;
        resetZoom();
        imgEl.src = slides[index].src;
        imgEl.alt = slides[index].alt;
        if (currentLabel) currentLabel.textContent = String(index + 1);
      };

      const go = (dir) => {
        if (total < 2) return;
        show(index + dir);
      };

      const open = (i) => {
        lastFocus = document.activeElement;
        show(i);
        overlay.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        overlay.querySelector('[data-close]').focus({ preventScroll: true });
      };

      const close = () => {
        overlay.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        resetZoom();
        const matchingItem = slideEls[index]?.closest('.pdp__media-item');
        if (matchingItem) activateMedia(matchingItem.dataset.index);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      };

      media.addEventListener('click', () => {
        const active = section.querySelector('.pdp__media-item.is-active');
        if (!active?.classList.contains('pdp__media-item--image')) return;
        const activeImage = active.querySelector('.pdp__image');
        const imageIndex = slideEls.indexOf(activeImage);
        if (imageIndex >= 0) open(imageIndex);
      });

      overlay.querySelector('[data-close]').addEventListener('click', close);
      overlay.querySelector('[data-prev]').addEventListener('click', () => go(-1));
      overlay.querySelector('[data-next]').addEventListener('click', () => go(1));

      document.addEventListener('keydown', (e) => {
        if (!overlay.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') go(-1);
        else if (e.key === 'ArrowRight') go(1);
      });

      stage.addEventListener(
        'wheel',
        (e) => {
          e.preventDefault();
          zoomToward(e.clientX, e.clientY, scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15));
        },
        { passive: false }
      );

      /* Unified pointer handling: tap-to-zoom, drag-to-pan, pinch, swipe */
      const pointers = new Map();
      let downX = 0;
      let downY = 0;
      let lastX = 0;
      let lastY = 0;
      let downTime = 0;
      let moved = false;
      let usedPinch = false;
      let pinchStartDist = 0;
      let pinchStartScale = 1;

      const distance = (pts) => Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);

      stage.addEventListener('pointerdown', (e) => {
        stage.setPointerCapture(e.pointerId);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        stage.classList.add('is-interacting');
        if (pointers.size === 1) {
          downX = lastX = e.clientX;
          downY = lastY = e.clientY;
          downTime = performance.now();
          moved = false;
          usedPinch = false;
          if (scale > 1.01) stage.classList.add('is-panning');
        } else if (pointers.size === 2) {
          const pts = [...pointers.values()];
          pinchStartDist = distance(pts);
          pinchStartScale = scale;
          usedPinch = true;
          moved = true;
        }
      });

      stage.addEventListener('pointermove', (e) => {
        if (!pointers.has(e.pointerId)) return;
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const pts = [...pointers.values()];

        if (pts.length === 2) {
          const dist = distance(pts);
          if (pinchStartDist > 0) {
            const midX = (pts[0].x + pts[1].x) / 2;
            const midY = (pts[0].y + pts[1].y) / 2;
            zoomToward(midX, midY, pinchStartScale * (dist / pinchStartDist));
          }
          return;
        }

        if (Math.abs(e.clientX - downX) > 6 || Math.abs(e.clientY - downY) > 6) moved = true;
        if (scale > 1.01) {
          tx += e.clientX - lastX;
          ty += e.clientY - lastY;
          constrain();
          applyTransform();
        }
        lastX = e.clientX;
        lastY = e.clientY;
      });

      const endPointer = (e) => {
        if (!pointers.has(e.pointerId)) return;
        pointers.delete(e.pointerId);

        if (pointers.size === 1) {
          const p = [...pointers.values()][0];
          lastX = p.x;
          lastY = p.y;
          pinchStartDist = 0;
          return;
        }
        if (pointers.size >= 2) return;

        stage.classList.remove('is-interacting', 'is-panning');
        const dt = performance.now() - downTime;

        if (!moved && dt < 300 && !usedPinch) {
          const r = imgEl.getBoundingClientRect();
          const overImg = downX >= r.left && downX <= r.right && downY >= r.top && downY <= r.bottom;
          if (!overImg) {
            close();
          } else if (scale > 1.01) {
            resetZoom();
          } else {
            zoomToward(downX, downY, 2.4);
          }
        } else if (scale <= 1.01 && total > 1 && moved && !usedPinch) {
          const dx = e.clientX - downX;
          const dy = e.clientY - downY;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
        }
      };

      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);
    })();

    /* Seamless mobile marquees. A duplicate set keeps the motion continuous;
       touch interaction pauses the row and it resumes after release. */
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const productTitle = section.querySelector('.pdp__title');
    const fitProductTitle = () => {
      if (!productTitle) return;

      productTitle.style.removeProperty('font-size');
      if (!mobileMedia.matches || productTitle.scrollWidth <= productTitle.clientWidth) return;

      const initialSize = Number.parseFloat(window.getComputedStyle(productTitle).fontSize);
      const fittedSize = (initialSize * productTitle.clientWidth) / productTitle.scrollWidth;
      productTitle.style.fontSize = `${fittedSize}px`;
    };

    document.fonts.ready.then(fitProductTitle);
    window.addEventListener('resize', fitProductTitle);
    mobileMedia.addEventListener('change', fitProductTitle);

    const initAutoSlider = (slider, itemSelector, pixelsPerSecond) => {
      if (!slider) return;
      const items = Array.from(slider.querySelectorAll(itemSelector));
      if (items.length < 2) return;

      let animationFrame;
      let resumeTimer;
      let previousTime;
      let scrollRemainder = 0;

      const removeClones = () => {
        slider.querySelectorAll('[data-auto-slider-clone]').forEach((clone) => clone.remove());
      };

      const addClones = () => {
        if (slider.querySelector('[data-auto-slider-clone]')) return;
        items.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-auto-slider-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          slider.appendChild(clone);
        });
      };

      const getLoopWidth = () => {
        const firstClone = slider.querySelector('[data-auto-slider-clone]');
        return firstClone ? firstClone.offsetLeft - items[0].offsetLeft : 0;
      };

      const normalizePosition = () => {
        const loopWidth = getLoopWidth();
        if (loopWidth <= 0) return;
        while (slider.scrollLeft >= loopWidth) slider.scrollLeft -= loopWidth;
      };

      const stop = () => {
        window.cancelAnimationFrame(animationFrame);
        window.clearTimeout(resumeTimer);
        previousTime = undefined;
        scrollRemainder = 0;
      };

      const move = (time) => {
        if (previousTime !== undefined) {
          // iOS Safari stores scrollLeft as a rounded integer, so the tiny
          // sub-pixel increments here (~0.4px/frame) would be discarded and
          // the strip would never move. Accumulate the fractional distance
          // and only ever apply whole pixels to scrollLeft.
          scrollRemainder += pixelsPerSecond * ((time - previousTime) / 1000);
          const wholePixels = Math.trunc(scrollRemainder);
          if (wholePixels !== 0) {
            slider.scrollLeft += wholePixels;
            scrollRemainder -= wholePixels;
          }
          normalizePosition();
        }
        previousTime = time;
        animationFrame = window.requestAnimationFrame(move);
      };

      const start = () => {
        stop();
        if (!mobileMedia.matches || reducedMotion.matches || document.hidden) {
          removeClones();
          slider.scrollLeft = 0;
          return;
        }
        addClones();
        normalizePosition();
        animationFrame = window.requestAnimationFrame(move);
      };

      const resume = () => {
        normalizePosition();
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(start, 900);
      };

      slider.addEventListener('pointerdown', stop, { passive: true });
      slider.addEventListener('pointerup', resume, { passive: true });
      slider.addEventListener('pointercancel', resume, { passive: true });
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', resume);
      mobileMedia.addEventListener('change', start);
      reducedMotion.addEventListener('change', start);
      document.addEventListener('visibilitychange', start);
      start();
    };

    initAutoSlider(section.querySelector('.pdp-perks__inner'), '.pdp-perks__item', 28);
    initAutoSlider(section.querySelector('.pdp-details__specs'), '.pdp-details__spec', 24);

    /* Scroll the right column from anywhere in the product section first.
       At either end, native page scrolling takes over. */
    const isInfoAtEdge = (deltaY) => {
      const atTop = info.scrollTop <= 0 && deltaY < 0;
      const atBottom = info.scrollTop + info.clientHeight >= info.scrollHeight - 1 && deltaY > 0;
      return atTop || atBottom;
    };
    const scrollInfoOrPage = (event) => {
      if (window.matchMedia('(max-width: 989px)').matches) return;
      if (event.ctrlKey || event.deltaY === 0 || isInfoAtEdge(event.deltaY)) return;
      event.preventDefault();
      info.scrollTop += event.deltaY;
    };
    if (info) {
      window.addEventListener('wheel', scrollInfoOrPage, { passive: false });
    }
    /* Copy coupon codes */
    section.querySelectorAll('.pdp__deal-code').forEach((button) => {
      button.addEventListener('click', () => {
        navigator.clipboard?.writeText(button.dataset.code);
        const label = button.querySelector('span');
        const original = label.textContent;
        label.textContent = button.dataset.copiedText || 'Copied!';
        setTimeout(() => (label.textContent = original), 1500);
      });
    });

    /* Tabs */
    const tabs = section.querySelectorAll('.pdp-details__tab');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        section.querySelectorAll('.pdp-details__panel').forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.panel === tab.dataset.tab);
        });
      });
    });

    /* Delivery estimate */
    const deliveryWidget = section.querySelector('[data-delivery-widget]');
    if (deliveryWidget) {
      const pincodeInput = deliveryWidget.querySelector('[data-pincode]');
      const checkButton = deliveryWidget.querySelector('[data-pincode-save]');
      const result = deliveryWidget.querySelector('[data-delivery-result]');
      const pincodePattern = /^[1-9][0-9]{5}$/;
      const storageKey = 'essencie-pincode';
      const readStoredPincode = () => {
        try {
          return window.localStorage.getItem(storageKey) || '';
        } catch (error) {
          return '';
        }
      };
      const storePincode = (pincode) => {
        try {
          window.localStorage.setItem(storageKey, pincode);
        } catch (error) {
          /* Delivery estimates still work when browser storage is unavailable. */
        }
      };
      const storedPincode = readStoredPincode();

      const setResult = (message, state = '') => {
        result.textContent = message;
        result.classList.toggle('is-success', state === 'success');
        result.classList.toggle('is-error', state === 'error');
      };

      const formatDate = (date) =>
        new Intl.DateTimeFormat(document.documentElement.lang || 'en-IN', {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
        }).format(date);

      const addBusinessDays = (date, numberOfDays) => {
        const deliveryDate = new Date(date);
        let daysAdded = 0;
        while (daysAdded < numberOfDays) {
          deliveryDate.setDate(deliveryDate.getDate() + 1);
          const day = deliveryDate.getDay();
          if (day !== 0 && day !== 6) daysAdded += 1;
        }
        return deliveryDate;
      };

      const fallbackEstimate = (pincode) => {
        const warehousePincode = deliveryWidget.dataset.warehousePincode.replace(/\D/g, '');
        const dispatchDays = Number(deliveryWidget.dataset.dispatchDays) || 0;
        let transitDays = Number(deliveryWidget.dataset.nationalDays) || 6;

        if (warehousePincode.length === 6 && pincode.slice(0, 2) === warehousePincode.slice(0, 2)) {
          transitDays = Number(deliveryWidget.dataset.localDays) || 2;
        } else if (warehousePincode.length === 6 && pincode.charAt(0) === warehousePincode.charAt(0)) {
          transitDays = Number(deliveryWidget.dataset.regionalDays) || 4;
        }

        const earliest = addBusinessDays(new Date(), dispatchDays + Math.max(1, transitDays - 1));
        const latest = addBusinessDays(new Date(), dispatchDays + transitDays + 1);
        return { earliest, latest };
      };

      const parseEndpointDate = (value) => {
        if (!value) return null;
        const parsed = new Date(value);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      };

      const requestEstimate = async (pincode) => {
        const endpoint = deliveryWidget.dataset.estimateEndpoint;
        if (!endpoint) return null;

        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('pincode', pincode);
        url.searchParams.set('variant_id', deliveryWidget.dataset.variantId);
        const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Delivery endpoint failed');
        return response.json();
      };

      const showEstimate = async (pincode) => {
        if (!pincodePattern.test(pincode)) {
          setResult(deliveryWidget.dataset.messageInvalid, 'error');
          pincodeInput.setAttribute('aria-invalid', 'true');
          return;
        }

        deliveryWidget.classList.add('is-loading');
        checkButton.disabled = true;
        pincodeInput.removeAttribute('aria-invalid');
        setResult(deliveryWidget.dataset.messageLoading);

        try {
          const estimate = await requestEstimate(pincode);
          if (estimate && estimate.serviceable === false) {
            setResult(deliveryWidget.dataset.messageUnavailable, 'error');
            return;
          }

          const fallback = fallbackEstimate(pincode);
          const singleDate = parseEndpointDate(estimate?.estimated_delivery_date);
          const minimumDays = Number(estimate?.min_days);
          const maximumDays = Number(estimate?.max_days);
          const earliest =
            parseEndpointDate(estimate?.earliest_date || estimate?.estimated_delivery_min) ||
            singleDate ||
            (minimumDays > 0 ? addBusinessDays(new Date(), minimumDays) : fallback.earliest);
          const latest =
            parseEndpointDate(estimate?.latest_date || estimate?.estimated_delivery_max) ||
            singleDate ||
            (maximumDays > 0 ? addBusinessDays(new Date(), maximumDays) : fallback.latest);
          const dates =
            earliest.toDateString() === latest.toDateString()
              ? formatDate(latest)
              : `${formatDate(earliest)} – ${formatDate(latest)}`;
          const location = estimate?.city || estimate?.location || '';
          const locationLabel = location ? `${deliveryWidget.dataset.messageLocation} ${location}. ` : '';

          storePincode(pincode);
          checkButton.textContent = deliveryWidget.dataset.labelChange;
          setResult(`${locationLabel}${deliveryWidget.dataset.messageEstimate} ${dates}`, 'success');
        } catch (error) {
          const fallback = fallbackEstimate(pincode);
          storePincode(pincode);
          checkButton.textContent = deliveryWidget.dataset.labelChange;
          setResult(
            `${deliveryWidget.dataset.messageEstimate} ${formatDate(fallback.earliest)} – ${formatDate(
              fallback.latest
            )}`,
            'success'
          );
        } finally {
          deliveryWidget.classList.remove('is-loading');
          checkButton.disabled = false;
        }
      };

      const detectPincode = async () => {
        const endpoint = deliveryWidget.dataset.locationEndpoint;
        if (deliveryWidget.dataset.autoDetect !== 'true' || !endpoint || storedPincode) return;

        try {
          const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const location = await response.json();
          const detectedPincode = String(
            location.pincode || location.postal_code || location.postal || location.zip || ''
          ).replace(/\D/g, '');
          if (!pincodePattern.test(detectedPincode)) return;
          pincodeInput.value = detectedPincode;
          await showEstimate(detectedPincode);
        } catch (error) {
          /* Location detection is an enhancement; manual entry remains available. */
        }
      };

      pincodeInput.value = storedPincode;
      pincodeInput.addEventListener('input', () => {
        pincodeInput.value = pincodeInput.value.replace(/\D/g, '').slice(0, 6);
        checkButton.textContent = deliveryWidget.dataset.labelCheck;
      });
      pincodeInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        showEstimate(pincodeInput.value);
      });
      checkButton.addEventListener('click', () => showEstimate(pincodeInput.value));

      if (storedPincode) {
        showEstimate(storedPincode);
      } else {
        detectPincode();
      }
    }

    /* Variant selection */
    if (!product || !product.variants) return;
    const moneyFormat = pdp.dataset.moneyFormat || '[amount]';
    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}|\[amount\]/, amount);
    };

    const optionFieldsets = section.querySelectorAll('.pdp__option');
    const update = () => {
      const selected = [];
      optionFieldsets.forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        selected[Number(fieldset.dataset.optionPosition) - 1] = checked ? checked.value : null;
      });
      const variant = product.variants.find((v) =>
        selected.every((value, i) => value === null || v.options[i] === value)
      );
      if (!variant) return;

      section.querySelector('[data-variant-id]').value = variant.id;
      if (deliveryWidget) deliveryWidget.dataset.variantId = variant.id;
      section.querySelector('[data-current-price]').textContent = formatMoney(variant.price);
      const compare = section.querySelector('[data-compare-price]');
      if (variant.compare_at_price > variant.price) {
        compare.textContent = formatMoney(variant.compare_at_price);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }

      const skuWrapper = section.querySelector('[data-sku-wrapper]');
      if (skuWrapper) {
        skuWrapper.querySelector('[data-sku]').textContent = variant.sku || '—';
      }

      const stock = section.querySelector('[data-stock]');
      stock.classList.toggle('pdp__stock--out', !variant.available);
      stock.querySelector('[data-stock-text]').textContent = variant.available
        ? stock.dataset.inStockText
        : stock.dataset.outOfStockText;
      section.querySelector('[data-atc]').disabled = !variant.available;
      const buyNow = section.querySelector('[data-buy-now]');
      if (buyNow) buyNow.disabled = !variant.available;

      if (variant.featured_image) {
        const match = section.querySelector(`.pdp__media-item[data-image-id="${variant.featured_image.id}"]`);
        if (match) activateMedia(match.dataset.index);
      }

      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    optionFieldsets.forEach((fieldset) => fieldset.addEventListener('change', update));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReels = (sectionRoot) => {
      if (sectionRoot.dataset.reelsInitialized === 'true') return;

      const viewport = sectionRoot.querySelector('[data-reels-viewport]');
      const track = sectionRoot.querySelector('[data-reels-track]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!viewport || !track) return;

      sectionRoot.dataset.reelsInitialized = 'true';

      let isPaused = reduceMotion.matches;
      let previousTime = 0;
      let dragStartX = 0;
      let dragStartY = 0;
      let dragged = false;
      let pointerActive = false;
      let suppressClick = false;
      let resumeTimer;
      let suppressClickTimer;
      let scrollRemainder = 0;
      const speed = 24;

      const muteVideo = (video) => {
        const item = video.closest('[data-reel-item]');
        const button = item?.querySelector('[data-reel-audio]');
        const mutedIcon = button?.querySelector('[data-reel-muted-icon]');
        const soundIcon = button?.querySelector('[data-reel-sound-icon]');

        video.muted = true;
        if (button) {
          button.setAttribute('aria-pressed', 'false');
          button.setAttribute('aria-label', sectionRoot.dataset.unmuteLabel);
        }
        if (mutedIcon) mutedIcon.toggleAttribute('hidden', false);
        if (soundIcon) soundIcon.toggleAttribute('hidden', true);
      };

      const setPaused = (paused, activeItem) => {
        isPaused = paused || reduceMotion.matches;
        for (const item of track.querySelectorAll('[data-reel-item]')) {
          item.classList.toggle('is-active', Boolean(activeItem) && item === activeItem);
        }
      };

      const resumeAfterDrag = () => {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(() => setPaused(false), 700);
      };

      viewport.addEventListener('pointerdown', (event) => {
        if (event.target.closest('button, a')) return;
        const item = event.target.closest('[data-reel-item]');
        const video = item?.querySelector('[data-reel-video]');

        dragStartX = event.clientX;
        dragStartY = event.clientY;
        dragged = false;
        pointerActive = true;
        suppressClick = false;
        window.clearTimeout(suppressClickTimer);
        window.clearTimeout(resumeTimer);
        setPaused(true, item);
        if (video) {
          attachSource(video);
          video.play().catch(() => {});
        }
      }, true);

      viewport.addEventListener('pointermove', (event) => {
        if (!pointerActive) return;
        if (Math.abs(event.clientX - dragStartX) > 8 || Math.abs(event.clientY - dragStartY) > 8) {
          dragged = true;
        }
      }, { passive: true });

      const finishPointerInteraction = () => {
        pointerActive = false;
        if (!dragged) return;
        suppressClick = true;
        window.clearTimeout(suppressClickTimer);
        suppressClickTimer = window.setTimeout(() => {
          suppressClick = false;
        }, 400);
        resumeAfterDrag();
      };

      viewport.addEventListener('pointerup', finishPointerInteraction, true);
      viewport.addEventListener('pointercancel', finishPointerInteraction, true);

      viewport.addEventListener(
        'click',
        (event) => {
          if (suppressClick) {
            suppressClick = false;
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          const item = event.target.closest('[data-reel-item]');
          setPaused(true, item);
        },
        true
      );

      for (const item of track.querySelectorAll('[data-reel-item]')) {
        const video = item.querySelector('[data-reel-video]');
        const audioButton = item.querySelector('[data-reel-audio]');

        if (!video) continue;

        const toggleAudio = () => {
          const willUnmute = video.muted;

          for (const otherVideo of track.querySelectorAll('[data-reel-video]')) {
            muteVideo(otherVideo);
          }

          if (willUnmute) {
            video.muted = false;
            audioButton.setAttribute('aria-pressed', 'true');
            audioButton.setAttribute('aria-label', sectionRoot.dataset.muteLabel);
            audioButton.querySelector('[data-reel-muted-icon]').toggleAttribute('hidden', true);
            audioButton.querySelector('[data-reel-sound-icon]').toggleAttribute('hidden', false);
            setPaused(true, item);
            attachSource(video);
            video.play().catch(() => {});
          }
        };

        let audioHandledByPointer = false;

        item.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          if (event.target.closest('button, a')) return;
          event.preventDefault();
          setPaused(true, item);
          attachSource(video);
          video.play().catch(() => {});
        });

        audioButton?.addEventListener('pointerdown', () => {
          setPaused(true, item);
          audioHandledByPointer = true;
          toggleAudio();
        });

        audioButton?.addEventListener('click', () => {
          if (audioHandledByPointer) {
            audioHandledByPointer = false;
            return;
          }
          toggleAudio();
        });
      }

      // Attach the <source> only when a reel is about to be seen. Until this
      // runs the <video> has no src, so nothing is downloaded.
      const attachSource = (video) => {
        if (video.dataset.reelLoaded) return;
        const src = video.dataset.reelSrc;
        if (!src) return;
        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        video.append(source);
        video.dataset.reelLoaded = 'true';
        video.load();
      };

      // Two gates must both be open before a reel plays:
      //   1. the section is somewhere in the document viewport, and
      //   2. the reel is scrolled into view within the horizontal carousel.
      // The inner observer alone used `root: viewport`, which only tracks
      // horizontal position — so reels played (and downloaded) while the whole
      // section was still far below the fold.
      let sectionInView = false;

      const playIfReady = (video) => {
        if (!sectionInView || isPaused || document.hidden) return;
        if (!video.dataset.reelVisible) return;
        attachSource(video);
        video.play().catch(() => {});
      };

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const video = entry.target;
            if (entry.isIntersecting) {
              video.dataset.reelVisible = 'true';
              playIfReady(video);
            } else {
              delete video.dataset.reelVisible;
              video.pause();
            }
          }
        },
        { root: viewport, threshold: 0.25 }
      );

      const videos = [...track.querySelectorAll('[data-reel-video]')];
      for (const video of videos) {
        observer.observe(video);
      }

      const sectionObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            sectionInView = entry.isIntersecting;
            if (sectionInView) {
              for (const video of videos) playIfReady(video);
            } else {
              for (const video of videos) video.pause();
            }
          }
        },
        { rootMargin: '200px 0px', threshold: 0 }
      );
      sectionObserver.observe(sectionRoot);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          for (const video of videos) video.pause();
        } else {
          for (const video of videos) playIfReady(video);
        }
      });

      reduceMotion.addEventListener('change', () => setPaused(reduceMotion.matches));

      const getItemStep = () => {
        const firstItem = track.querySelector('[data-reel-item]');
        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return firstItem ? firstItem.getBoundingClientRect().width + gap : 0;
      };

      const canLoop = () => track.scrollWidth > viewport.clientWidth + 2;

      const createLeftBuffer = () => {
        if (!canLoop()) return;
        const step = getItemStep();
        const lastItem = track.querySelector('[data-reel-item]:last-child');
        if (!lastItem || step <= 0) return;
        track.prepend(lastItem);
        viewport.scrollLeft = step;
      };

      const normalizeTrack = () => {
        if (!canLoop()) return;
        const step = getItemStep();
        if (step <= 0) return;

        if (viewport.scrollLeft >= step * 2) {
          const firstItem = track.querySelector('[data-reel-item]');
          if (firstItem) {
            track.append(firstItem);
            viewport.scrollLeft -= step;
          }
        } else if (viewport.scrollLeft <= 0) {
          const lastItem = track.querySelector('[data-reel-item]:last-child');
          if (lastItem) {
            track.prepend(lastItem);
            viewport.scrollLeft += step;
          }
        }
      };

      const animate = (timestamp) => {
        const elapsed = Math.min((timestamp - previousTime) / 1000, 0.05);
        previousTime = timestamp;

        if (!isPaused && canLoop()) {
          // iOS Safari stores scrollLeft as a rounded integer, so sub-pixel
          // increments (~0.4px/frame) get discarded and the rail never moves.
          // Accumulate the fractional distance here and only ever apply whole
          // pixels to scrollLeft.
          scrollRemainder += speed * elapsed;
          const wholePixels = Math.trunc(scrollRemainder);
          if (wholePixels !== 0) {
            viewport.scrollLeft += wholePixels;
            scrollRemainder -= wholePixels;
          }
        }

        normalizeTrack();

        window.requestAnimationFrame(animate);
      };

      createLeftBuffer();
      window.requestAnimationFrame(animate);
    };

    for (const sectionRoot of document.querySelectorAll('[data-reels-section]')) {
      initializeReels(sectionRoot);
    }

    document.addEventListener('shopify:section:load', (event) => {
      const sectionRoot = event.target.querySelector('[data-reels-section]');
      if (sectionRoot) initializeReels(sectionRoot);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-related-url]').forEach(async (sectionEl) => {
    const grid = sectionEl.querySelector('[data-related-grid]');
    if (!grid || grid.children.length > 0) return;

    try {
      const response = await fetch(sectionEl.dataset.relatedUrl);
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fetchedGrid = html.querySelector('[data-related-grid]');
      if (fetchedGrid && fetchedGrid.children.length > 0) {
        grid.innerHTML = fetchedGrid.innerHTML;
      } else {
        sectionEl.hidden = true;
      }
    } catch (error) {
      sectionEl.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shop-look__button[data-variant-ids]').forEach((button) => {
    button.addEventListener('click', async () => {
      const items = button.dataset.variantIds
        .split(',')
        .filter(Boolean)
        .map((id) => ({ id: Number(id), quantity: 1 }));
      if (items.length !== 2) return;

      const original = button.textContent;
      button.disabled = true;
      button.textContent = button.dataset.addingText || original;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) throw new Error('add failed');
        window.location.href = button.dataset.cartUrl || '/cart';
      } catch (error) {
        button.textContent = button.dataset.errorText || original;
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = original;
        }, 1800);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTestimonials = (scope = document) => {
      const mobileQuery = window.matchMedia('(max-width: 749px)');

      for (const section of scope.querySelectorAll('.testimonials')) {
        if (section.dataset.paginationReady === 'true') continue;

        const grid = section.querySelector('.testimonials__grid');
        const dotGroups = [...section.querySelectorAll('[data-testimonial-dots]')];
        const cards = [...section.querySelectorAll('.testimonials__card')];
        if (!grid || dotGroups.length === 0 || cards.length === 0) continue;

        section.dataset.paginationReady = 'true';
        let activePage = 0;
        let scrollFrame;

        const cardsPerPage = () => (mobileQuery.matches ? 1 : 3);
        const pageCount = () => Math.ceil(cards.length / cardsPerPage());

        const currentDots = () => {
          const mode = mobileQuery.matches ? 'mobile' : 'desktop';
          return dotGroups.find((group) => group.dataset.testimonialDots === mode);
        };

        const setActiveDot = (page) => {
          const dots = currentDots();
          if (!dots) return;

          const buttons = [...dots.querySelectorAll('.testimonials__dot')];
          activePage = Math.max(0, Math.min(page, buttons.length - 1));

          for (const [index, button] of buttons.entries()) {
            const isActive = index === activePage;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-current', isActive ? 'true' : 'false');
          }
        };

        const pageFromScroll = () => {
          const gridRect = grid.getBoundingClientRect();
          const anchor = mobileQuery.matches ? gridRect.left + gridRect.width / 2 : gridRect.left;
          let nearestPage = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;

          for (let page = 0; page < pageCount(); page += 1) {
            const card = cards[Math.min(page * cardsPerPage(), cards.length - 1)];
            const cardRect = card.getBoundingClientRect();
            const cardAnchor = mobileQuery.matches ? cardRect.left + cardRect.width / 2 : cardRect.left;
            const distance = Math.abs(cardAnchor - anchor);

            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestPage = page;
            }
          }

          setActiveDot(nearestPage);
        };

        const scrollToPage = (page) => {
          const card = cards[Math.min(page * cardsPerPage(), cards.length - 1)];
          const gridRect = grid.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();
          let left = grid.scrollLeft + cardRect.left - gridRect.left;

          if (mobileQuery.matches) {
            left -= (grid.clientWidth - card.offsetWidth) / 2;
          }

          grid.scrollTo({ left, behavior: 'smooth' });
          setActiveDot(page);
        };

        for (const dots of dotGroups) {
          dots.addEventListener('click', (event) => {
            const button = event.target.closest('[data-testimonial-page]');
            if (!button) return;

            scrollToPage(Number(button.dataset.testimonialPage));
          });
        }

        grid.addEventListener('scroll', () => {
          cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(pageFromScroll);
        }, { passive: true });

        mobileQuery.addEventListener('change', () => {
          activePage = 0;
          setActiveDot(0);
          grid.scrollTo({ left: 0 });
        });

        setActiveDot(0);
      }
    };

    initializeTestimonials();
    document.addEventListener('shopify:section:load', (event) => initializeTestimonials(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
